function openMenu(){
  $('.metalmenu').slideDown();
}

function closeMenu(){
  $('.metalmenu').slideUp();
}

function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function updateProductPrice(p) {
  var shopifyFinalPrice = 0
  if (p % 1 === 0) {
    shopifyFinalPrice = fraction.format(p);
  } else {
    shopifyFinalPrice = formatter.format(p);
  }
  /* Implementation for Bespoke Pre Cart */
  var finalTotalPricePreCart = 0
  var diamondPriceText = $('#preCartDiamondPrice').text();
  var settingPriceText = $('#actualSettingprice').text();
  // Remove the dollar sign and commas from the prices
  var diamondPrice = parseFloat(diamondPriceText.replace('$', '').replace(/,/g, ''));
  var settingPrice = parseFloat(settingPriceText.replace('$', '').replace(/,/g, ''));
  finalTotalPricePreCart = diamondPrice + settingPrice;
  if (finalTotalPricePreCart % 1 === 0) {
    finalTotalPricePreCart = fraction.format(finalTotalPricePreCart);
  } else {
    finalTotalPricePreCart = formatter.format(finalTotalPricePreCart);
  }
  finalTotalPricePreCart && finalTotalPricePreCart !== 0 ? finalTotalPricePreCart : shopifyFinalPrice
  // Appending Final Calculated Price
  $("#preCartTotalProductPrice").text(finalTotalPricePreCart)
  $("#openEngravingModal span").text(`Add to bag`)
  $(".engravingModal_btn").find('.markedPopUpPrice').text(`${shopifyFinalPrice}`)
}

/** * Select Diamond display formatted sale price * **/
function updateMarkedUpPricePrice(p) {
  var shopifyFinalPrice = 0
  if (p % 1 === 0) {
    shopifyFinalPrice = fraction.format(p);
  } else {
    shopifyFinalPrice = formatter.format(p);
  }
  $(".markedUpPrice").text(shopifyFinalPrice)
  updatePriceThreeStepProcess(shopifyFinalPrice);
}

function updateDiamondlabel() {
  var selectedDiamond = getParameterByName('diamondType', window.location.href);
  var diamondShapeLabel = document.getElementById('diamondShapeLabel');
  if (diamondShapeLabel && selectedDiamond) {
    diamondShapeLabel.textContent = 'Diamond Shape: ' + selectedDiamond;
  }
  updateSelectedClass(selectedDiamond);
}

function updateSelectedClass(selectedDiamond) {
  var buttons = document.querySelectorAll('.diamond-shape-classd');
  var defaultSelectedDiamond = document
    .querySelector('.ProductForm__SelectedValue__diamondshape')
    ?.textContent
    ?.trim();
  buttons.forEach(function(button) {
    button.classList.remove('selected-diomand-class');
    // Priority 1: URL param
    if (selectedDiamond && button.dataset.value === selectedDiamond) {
      button.classList.add('selected-diomand-class');
    }
    // Priority 2: default only if URL param not present
    else if (!selectedDiamond && button.dataset.value === defaultSelectedDiamond) {
      button.classList.add('selected-diomand-class');
    }
  });
}

updateDiamondlabel();

var historyState = {};
// To reduce document size assigning window.SwymProductInfo.product value to productVal and commenting the old logic
var productVal      = window.SwymProductInfo.product;
var defaultVariant  = currentVariantJson
var selectedDiamond = null
var unparsedDiamond = localStorage.getItem("seletedDiamond")
if(unparsedDiamond) {
  selectedDiamond = JSON.parse(unparsedDiamond)
}

$( window ).scroll(function() {
  $(".Product__Info").css({"top": - $(window).scrollTop()+'px'})
});

$( window ).resize(function() {
  var boxClass = "ProductForm__mobile-view";
  if ($(window).width() >= 768) {
    boxClass ="product-diamond-shape-selection";
  }
  if ($(window).width() >= 768) {
    $(".product-diamond-shape-selection").show()
    $(".ProductForm__mobile-view").hide()
  } else {
    $(".product-diamond-shape-selection").hide()
    $(".ProductForm__mobile-view").show();
    $(".Collapsible__Button.onmobile").css({"height":"auto","overflow":"visible"})
  }
});

function getRawDiamondInfo() {
  var _raw_diamond_info = localStorage.getItem( '_raw_diamond_info')
  if (_raw_diamond_info) {
    let rawDiamondInfo = JSON.parse(_raw_diamond_info)
    return rawDiamondInfo.diamondObj.split('_');
  } else {
    return []
  }
}

$(document).ready(function() {
  var product_url = window.location.href;
  var diamondType = getParameterByName('diamondType', product_url);
  var metal = getParameterByName('metal', product_url);
  var variantId = getParameterByName('variant', product_url);

  if(diamondType) {
    var lowerCaseDiamond = diamondType.toLocaleLowerCase()
    $('.diamond-shape-list.product-item-diamond-shape>li').removeClass('active')
    $('.diamond-shape-list.product-item-diamond-shape').find(`li[itemid="${lowerCaseDiamond}"]`).addClass('active')
    $("#engaged").val(lowerCaseDiamond)
  }

  if (!diamondType && !metal && !variantId) {
    variantId = $('#newDiamondShapeSelect > option:eq(0)').attr('vid');
    diamondType = $('#newDiamondShapeSelect > option:eq(0)').attr('data-value');
    metal = $('#metalSelectNew > option:eq(0)').attr('data-value');
    // If diamondType is not set then getting value from default diamond
    if(!diamondType && diamondType !== "" ) {
      diamondType = defaultVariant.option1
    }
    // If metal is not set then getting value from default diamond
    if(!metal && metal !== "" ) {
      metal = defaultVariant.option2
    }
    // If variantId is not set then getting value from default diamond
    if(!variantId && variantId !== "" ) {
      variantId = defaultVariant.id
    }
    history.pushState(historyState, "", `?variant=${variantId}&diamondType=${diamondType}&metal=${metal}`)
    onFirstLoad();
  } else {
    onFirstLoad();
  }

  if (window.history && window.history.pushState) {
    $(window).on('popstate', function() {
      var hashLocation = location.hash;
      var hashSplit = hashLocation.split("#!/");
      var hashName = hashSplit[1];
      if (hashName !== '') {
        var hash = window.location.hash;
        if (hash === '') {
          window.location.href = "/collections/vow-engagement-rings"
        }
      }
    });
  }

  $("body").on("click", function(){
    var aeFlag = $(".product-diamond-shape-selection button.select-ring-size-btn").attr("aria-expanded")
    if(aeFlag === true || aeFlag === "true") {
      $("html").addClass("no-scroll-sz")
    } else {
      $("html").removeClass("no-scroll-sz")
    }
  })
  
  /* Insert Select Ring Size Value: BESPOKE PDP */
  var selectedRingSize = getParameterByName('ringSize');
  selectedRingSize ? $('#newSizeSelect').attr('value', selectedRingSize) : ""
  selectedRingSize ? $('.ProductForm__SelectedValue__Ringsize').text(selectedRingSize) : 'Select'

  // If diamond variable is present in localstorage then doing all operations
  var _raw_diamond_info = localStorage.getItem( '_raw_diamond_info')
  var isPreCart = getParameterByName('preCart');
  
  if (_raw_diamond_info) {
    let rawDiamondInfo = JSON.parse(_raw_diamond_info)
    var StartingPrice = removeDoller($(".markedUpPrice").text())
    var diaObj = rawDiamondInfo.diamondObj.split('_');
    if (diaObj.length > 4) {
      var vals = diaObj.length > 4 ? diaObj[0] +' - '+ diaObj[4] : 'Select';
      $("#selectedDiamondObj").val(rawDiamondInfo.diamondObj)
      $("#selectedDiamondShape").val(rawDiamondInfo.diamondTitle)
    }
    setTimeout(() => {
      var newproductStartingPrice = StartingPrice * 100
      makeVariantSelectedPrice(newproductStartingPrice)
    }, 100)

    /* ============= Setting Pre-Cart-values =================== */
    if(isPreCart === 'true') {
      $("#preCartDiamondShape").text(rawDiamondInfo.diamondShape)
      if (diaObj.length) {
        $("#preCartCaratWeight").text(parseFloat(diaObj[0]).toFixed(2))
        $("#preCartClarity").text(diaObj[2])
        $("#preCartCutValue").text(diaObj[3])
        $("#preCartColor").text(diaObj[1])
        $("#preCartCaratMeasurements").text(diaObj[5])
        $("#preCartDiamondId").text(rawDiamondInfo.uniqueidentifier) 
        $("#preCartDiamondPrice").text(diaObj[4])
        $("#preCartRingSize").text(selectedRingSize)
        $("#selectedDiamondCarat").text(parseFloat(diaObj[0]).toFixed(2) + " " + rawDiamondInfo.diamondShape + " " + "Diamond")
        if (rawDiamondInfo.selectedDiamondType && rawDiamondInfo.selectedDiamondType !== "natural") {
          $("#preCartDiamondType").text('Lab Grown Diamond')
        } else {
          $("#preCartDiamondType").text('Natural Diamond')
        }
      }
    } 
  }
})

function onFirstLoad() {
  let formData = getFormData()
  $("#engravingModal .close-modal-popup").on('click', function(event) {
    modalClose();
  })
  $('.hamburger').on('click', function(event) {
    $(this).toggleClass('click');
    return $(this).hasClass('click') ? openMenu() : closeMenu();
  });
  var boxClass = "ProductForm__mobile-view";
  if ($(window).width() >= 768) {
    boxClass ="product-diamond-shape-selection";
  }
  if ($(window).width() >= 768) {
    $(".product-diamond-shape-selection").show()
    $(".ProductForm__mobile-view").hide()
    $(".Drawer__Main").css("flex", "1 1 auto");
  } else {
    $(".product-diamond-shape-selection").hide()
    $(".ProductForm__mobile-view").show();
    $(".Drawer__Main").css("flex", "0 0 auto");
  }
  showDesignDetails();
}

function clickOnBody() {
  $("body").trigger("click")
  $(".Popover__Close").trigger('click');
  $(".ringSizeNew").removeClass("required_red_color")
}

function clickOnBodyMobile(event, id, type) {
  event.stopImmediatePropagation()
  var val = $(id).attr('data-value')
  var currentUrl = window.location.href;
  if (type === 'Band') {
    let textVal = $(id).text()
    if ($(id).hasClass("hiddenhalo")) {
      $(".ProductForm__SelectedValue__"+type).text(textVal);
    } else {
      $(".ProductForm__SelectedValue__"+type).text(textVal);
    }
    $("#newBandSelect").attr('value', val);
    variantChange(this, type.toLowerCase())
  } else if (type === 'Ringsize') {
    $(".ProductForm__SelectedValue__"+type).text(val);
    $("#newSizeSelect").val(val)
    var grabMetalValue = getParameterByName("metal");
    var paramsToAddOrUpdate = {
      metal: grabMetalValue, 
      ringSize: val 
    };
    addOrUpdateURLParameter(paramsToAddOrUpdate);
    $('#selectDiamondPageLink, #reviewYourDesignPageLink').removeClass('choose-settings-grey-btn');
    $('#chooseDiamond').addClass('show-hand-cursor');
    $('.error-message-select-ring-size').addClass('hide');
  }
  $(".ringSizeNew").removeClass("required_red_color")
  $("body").trigger("click")
  $(".Popover__Close").trigger('click');
  $('#openEngravingModal').removeAttr("disabled").removeClass('btn-disabled-items ').addClass("Button Button-primary");
}

function addOrUpdateURLParameter(params) {
  var url = window.location.href;
  var baseUrl = url.split('?')[0];
  var queryString = url.includes('?') ? url.split('?')[1] : '';
  var queryParams = new URLSearchParams(queryString);
  // Loop through the params object and set the parameters
  for (var param in params) {
    if (params.hasOwnProperty(param)) {
      queryParams.set(param, params[param]); // Add or update the parameter
    }
  }
  // Construct the query string manually to avoid encoding
  var newQueryString = [];
  queryParams.forEach((value, key) => {
    newQueryString.push(key + '=' + value);
  });
  var newUrl = baseUrl + '?' + newQueryString.join('&');
  history.pushState({}, '', newUrl);
}

function makeVariantSelectedPrice(price) {
  var boxClass = "ProductForm__mobile-view";
  if ($(window).width() >= 768) {
    boxClass ="product-diamond-shape-selection";
  }
  if (price) {
    var defaultDiamondShape = getDiamondType()
    if(!defaultDiamondShape) {
      defaultDiamondShape = selectedDiamondShape
    }
    let basePrice = price
    basePrice = basePrice !== 0 ? removeDoller(basePrice / 100) : removeDoller(basePrice);
    var productBandPrice = $("#productBandPrice").val() !== '' ? removeDoller($("#productBandPrice").val()) : 0
    basePrice = basePrice + removeDoller(productBandPrice)

    updateMarkedUpPricePrice(basePrice)
    if ($("#selectedDiamondObj").length && $("#selectedDiamondObj").val() !== '') {
      $(".ProductMeta__PriceLists").removeAttr('style')
      var oldAmt        = removeDoller($(".markedUpPrice").attr('defaultAmt'))
      var staringPrice  = removeDoller($(".markedUpPrice").text())
      let markedUpPrice = ($("#selectedDiamondObj").val()).split('_');
      let markedUpamt   = 0
      if (markedUpPrice.length > 4) {
        markedUpamt = removeDoller(markedUpPrice[4]);
      }
      let finalPrice = parseFloat(staringPrice) + parseFloat(markedUpamt)
      if (oldAmt !== 0) {
        $(".markedUpPrice").attr('defaultAmt', markedUpamt)
      }
      finalPrice = parseFloat(finalPrice) - parseFloat(oldAmt)
      if (!isNaN(finalPrice)) {
        /** * Getting the diamondInfo i.e price from localstorage and adding with variant price * **/
        var rawDiamondInfo = getRawDiamondInfo()
        if (rawDiamondInfo && rawDiamondInfo.length > 4) {
          var diamondPrice = removeDoller(rawDiamondInfo[4]);
          if (diamondPrice) {
            finalPrice = finalPrice + parseInt(diamondPrice);
          }
        }
        updateProductPrice(finalPrice)
      }
    } else {
      setTimeout(() => {
        var firstDefaultAmt = 0
        var items = $("#diamond__right").find(".table__accordion-item.withoutsoldout:eq(0)").find(".emerald__accordion-list li:eq(5)").text();
        $(".markedUpPrice").attr("defaultAmt", removeDoller(firstDefaultAmt))
        basePrice = basePrice + removeDoller(firstDefaultAmt)
        if (!isNaN(basePrice)) {
          /** * Getting the diamondInfo i.e price from localstorage and adding with variant price * **/
          var rawDiamondInfo = getRawDiamondInfo()
          if (rawDiamondInfo && rawDiamondInfo.length > 4) {
            var diamondPrice = removeDoller(rawDiamondInfo[4]);
            if (diamondPrice) {
              basePrice = basePrice + parseInt(diamondPrice);
            }
          }
          updateProductPrice(basePrice)
        }
      }, 100)
    }
  }
}

function getVariantId(info, cb) {
  let url = String(window.location.href)
  let metalVal = $('.ProductForm__SelectedValue__Metal').html()
  if(!info.metal) {
  	info.metal = metalVal.trim()
  }
  if (url.includes('&metal')) {
    if ((url.split('&metal=')[1]).includes('%20')) {
      info.metal = metalVal.trim().replace("Metal: ", "");
    }
  }
  if (info.diamond === 'Antique-Style+Cushion') info.diamond = "Antique-Style Cushion"
  if (info.diamond === 'Antique-Style+Round') info.diamond = "Antique-Style Round"
  if (info.diamond === 'Emerald+(East/West)') info.diamond = "Emerald (East/West)"
  if (info.diamond === 'Emerald+(North/South)') info.diamond = "Emerald (North/South)"
  
  var selectedVariant = null
  var variants = grabAllVariants
  info.metal = info.metal.replace(/^Metal:\s*/, "");
  if (variants.length) {
    variants.map((v, i) => {
      if(v.option3 && v.option3 !== null){
        if(v.option1 && v.option2 &&
          removeChar(`${v.option1}`.toLowerCase()) === removeChar(`${info.diamond}`.toLowerCase()) &&
          removeChar(`${v.option2}`.toLowerCase()) === removeChar(`${info.metal}`.toLowerCase()) &&
          removeChar(`${v.option3}`.toLowerCase()) === removeChar(`${info.halo}`.toLowerCase())) {
          selectedVariant = v
        }
      } else {
        if(v.option1 && v.option2 &&
          removeChar(`${v.option1}`.toLowerCase()) === removeChar(`${info.diamond}`.toLowerCase()) &&
          removeChar(`${v.option2}`.toLowerCase()) === removeChar(`${info.metal}`.toLowerCase())) {
          selectedVariant = v
        }
      }
    })
    cb(selectedVariant)
  } else {
    cb(null)
  }
}

var designDetailsClicked = false;
$(".ProductForm__Item").click(function(){
  if(this.children[0].innerHTML.indexOf("Design Details") === 0){
    designDetailsClicked = true;    
  } else {
    designDetailsClicked = false; 
  }
}) 

// Function to get query parameters
function getQueryParam(param) {
  var urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}

// Function to extract and log the variant ID
function logVariantId() {
  var variantId = getQueryParam('variant');
  associatedVariantIdUpdate(variantId)
}

variantChange = (clickedItem, type) => {
  setTimeout(logVariantId, 30);
  if(!clickedItem.designDetailsClicked){
    $(".customImageLoader").show();
  }

  var boxClass = "ProductForm__mobile-view";
  if ($(window).width() >= 768) {
    boxClass ="product-diamond-shape-selection";
  }

  var product_url = window.location.href;
  let diamondAndMetal = {diamond: null, metal: null, halo: null}
  var productId = $(clickedItem).attr("data-productid")
  var urlVariantId = getParameterByName('variant', window.location.href);
  if(!urlVariantId) {
    urlVariantId = defaultVariant.id
  }

  var bandType = $('#newBandSelect').val()
  var ringSize = $('#newSizeSelect').val()
  if (bandType === undefined) {
    bandType = $("#productBandType").val();
    if( bandType == "" ) {
      bandType = "Original Design"
    }
  }
  
  if(type) {
    var value = $(clickedItem).attr("data-value")
    if( type === "d" ) {
      $(".ProductForm__SelectedValue__diamondshape").text(value)
      $('.newDiamondShapeSelect').val(value);
      var lowerCaseDiamond = value.toLocaleLowerCase()
      $('.diamond-shape-list.product-item-diamond-shape>li').removeClass('active')
      $('.diamond-shape-list.product-item-diamond-shape').find(`li[itemid="${lowerCaseDiamond}"]`).addClass('active')
      $("#engaged").val(lowerCaseDiamond)

      //deSelectDiamondOnVariantChange() // Deselecting the default variants
      diamondAndMetal.diamond = value

      // In url the metal string has no space so getting original name
      var selectedMetal = getParameterByName('metal', window.location.href);
      if(!selectedMetal) {
        selectedMetal = defaultVariant.option2
      } else {
        if (selectedMetal === '14KYellowGold') {
          selectedMetal = getMetalOtherNames(selectedMetal)[1]
        } else if(selectedMetal === '14kYellowGold'){
          selectedMetal = getMetalOtherNames(selectedMetal)[7] 
        } else if(selectedMetal === '14KRoseGold'){
          selectedMetal = getMetalOtherNames(selectedMetal)[3]
        } else if(selectedMetal === '14kRoseGold'){
          selectedMetal = getMetalOtherNames(selectedMetal)[6] 
        } else {
          selectedMetal = getMetalOtherNames(selectedMetal)[0]
        }
      }
      diamondAndMetal.metal = selectedMetal
      diamondAndMetal.halo = bandType
    }
    else if( type === "m" ) {
      let metalCaratName = ''
      $(".ProductForm__SelectedValue__Metal").text(value)
      $('#metalSelectNew').val(value);
      // Getting the selected diamond
      var selectedDiamond = getParameterByName('diamondType', window.location.href);
      if(!selectedDiamond) {
        selectedDiamond = defaultVariant.option1
      }
      diamondAndMetal.diamond = selectedDiamond
      diamondAndMetal.metal = value
      diamondAndMetal.halo = bandType
    }
    else if (type === 'band') {
      $("#productBandType").val(bandType)
      // Getting the selected diamond
      var selectedDiamond = getParameterByName('diamondType', window.location.href);
      if(!selectedDiamond) {
        selectedDiamond = defaultVariant.option1
      }
      diamondAndMetal.diamond = selectedDiamond
      // In url the metal string has no space so getting original name
      var selectedMetal = getParameterByName('metal', window.location.href);
      if(!selectedMetal) {
        selectedMetal = defaultVariant.option2
      } else {
        selectedMetal = getMetalOtherNames(selectedMetal)[0]
      }
      diamondAndMetal.metal = selectedMetal
      diamondAndMetal.halo = bandType;
    }
  }

  getVariantId(diamondAndMetal, (variant) => {
    clickOnBody();
    if(variant) {
      // Change the text of Add to cart button
      if(variant.available) {
        $('#openEngravingModal').find("span.ButtonText").text("Add to cart")
        $('#openEngravingModal').attr("disabled", false)
        $('#openEngravingModal').find("span.markedUpPrice").removeClass("hide")
        $('#openEngravingModal').removeClass("Button--selected-gray")
        $('div.clickable').removeClass("soldOut")
      } else {
        $('#openEngravingModal').find("span.ButtonText").text("sold out")
        $('#openEngravingModal').attr("disabled", "disabled")
        $('#openEngravingModal').find("span.markedUpPrice").addClass("hide")
        $('#openEngravingModal').addClass("Button--selected-gray")
        $('div.clickable').addClass("soldOut")
      }
      $(".ProductForm__SelectedValue__Metal").text("Metal: "+diamondAndMetal.metal)
      var metalClass = diamondAndMetal.metal.toLowerCase().replace(" ", "-");
      $(".color-variants-select").removeClass("rose-gold yellow-gold platinum").addClass(metalClass)
      let variantPrice = variant.price
      let variantId = variant.id

      let selectedVariantId = getParameterByName('variant', product_url);
      if(!selectedVariantId) {
        selectedVariantId = defaultVariant.id
      }

      let diamondTypeId = getParameterByName('diamondType', product_url);
      if(!diamondTypeId) {
        diamondTypeId = defaultVariant.option1
      }

      // In url the metal string has no space so getting original name
      let metal = getParameterByName('metal', product_url);
      if(!metal) {
        metal = defaultVariant.option2
      } else {
        metal = getMetalOtherNames(metal)[0]
      }

      $('[name="id"] option').val(variantId);
      if(selectedVariantId && diamondTypeId && metal) {
        let url1 = updateQueryStringParameter(product_url, 'variant', variantId)
        let url2 = updateQueryStringParameter(url1, 'diamondType', variant.option1)
        let url3 = updateQueryStringParameter(url2, 'metal', removeChar(variant.option2))
        history.pushState(historyState, "", url3)
        showProductImages(variantPrice, type);
        // Generating the select diamond page link after all url updates
        generateSelectDiamondLink()
      } else {
        history.pushState(historyState, "", `?diamondType=${variant.option1}&metal=${removeChar(variant.option2)}&variant=${variantId}`)
        showProductImages(variantPrice, type);
        // Generating the select diamond page link after all url updates
        generateSelectDiamondLink()
      }
    } else {
      $(".customImageLoader").hide();
      console.log(diamondAndMetal, "Selected variation combination is not present")
      showErrorMessage("Selected variation combination is not present")
    }
  })
}

function showProductImages(price, type) {
  setTimeout(() => {
    if(price) {
      productStartingPrice = price
      showDesignDetails();
      if(type === 'd' || type === 'm' || type === 'band') {
        makeVariantSelectedPrice(price)
      }
      getVariantVideoUrl(productId)
    }
  },100)
}

function getFormData() {
  var product_url = window.location.href;
  var boxClass = "ProductForm__mobile-view";
  if ($(window).width() >= 768) {
    boxClass ="product-diamond-shape-selection";
  }

  let bandWidth = grabBandWidth
  let formData = $('form[action="/cart/add"]').serializeArray();
  var selectedVariantId = getParameterByName('variant', product_url);
  if(!selectedVariantId) {
    selectedVariantId = defaultVariant.id
  }

  let ringSize = getParameterByName('ringSize');
  let dataToSend = { quantity: 1, id: selectedVariantId,
  properties: { Ring_Size: null, Diamond: null, DiamondId: null } }
  formData.push({name: "properties[BandWidth]", value: bandWidth})
  formData.push({name: "properties[Ring_Size]", value: ringSize})
  formData.map(function(item, index) {
    if( item.name !== "form_type" && item.name !== "utf8" ) {
      if(item.name === "properties[Ring_Size]") {
        dataToSend['properties']['Ring_Size'] = ringSize
      }
      if(item.name === "properties[Diamond]") {
        dataToSend['properties']['Diamond'] = $("#selectedDiamondShape").val();
      }
      if(item.name === "properties[DiamondObj]") {
        let diamondInformations = item.value.split("_")
        dataToSend['properties']['Carat'] = diamondInformations[0]
        dataToSend['properties']['Clarity'] = diamondInformations[2]
        dataToSend['properties']['Cut'] =  diamondInformations[3]
        dataToSend['properties']['Color'] =  diamondInformations[1]
        dataToSend['properties']['Diamond Measurement'] = diamondInformations[5]
        dataToSend['properties']['_markupPrice'] = diamondInformations[4]
      }
    }
  })
  return dataToSend;
}

function modalClose() {
  if ($("#engravingModal").hasClass('open')) {
    $("#engravingModal").removeClass("open")
    $("body,html").removeClass("modal-window-open");
  }
}

function showDesignDetails() {
  var product_url = window.location.href;
  var diamondType = getParameterByName('diamondType', product_url);
  if(!diamondType) {
    diamondType = defaultVariant.option1
  }
  var metal = getParameterByName('metal', product_url);
  if(!metal) {
    metal = defaultVariant.option2
  }
  var variantId = getParameterByName('variant', product_url);
  if(!variantId) {
    variantId = defaultVariant.id
  }

  var designArr = [];
  var defaultitle = '';
  var selected = '';
  $(".band-dubble-item").addClass("hide")
  if(diamondType && metal) {
    productVal.variants.map((item, i) => {
    if(removeChar(item.option1.toLowerCase()) === removeChar(diamondType.toLowerCase())
      && removeChar(item.option2.toLowerCase()) === removeChar(metal.toLowerCase()) &&
      item.option3 && item.option3 !== '') {
        if (defaultitle === '' && String(item.id) === String(variantId)) {
          defaultitle = item.option3;
          selected = removeChar(defaultitle.toLowerCase())
        }
        designArr.push(item)
      }
    })
  }

  if (defaultitle !== '') {
    $("#productBandType").val(defaultitle);
    $("#newBandSelect").attr('value', defaultitle);
    $('#newBandSelect option[value="'+defaultitle+'"]').attr("selected",true);
  }
  if (designArr.length) {
    if (designArr.length > 1) {
      var originalPrice = 0;
      var hiddenhaloPrice = 0;
      designArr.map((item) =>{
        if(item.option3 && removeChar(item.option3.toLowerCase()) === 'originaldesign'){
          originalPrice = item.price;
          $('.originaldesign').attr("vid",item.id);
        } else if(item.option3 && removeChar(item.option3.toLowerCase()) === 'hiddenhalo'){
          hiddenhaloPrice = item.price;
          $('.hiddenhalo').attr("vid",item.id);
        }
      })

      var hiddenHaloPrice = parseFloat(hiddenhaloPrice) - parseFloat(originalPrice)
      hiddenHaloPrice =  hiddenHaloPrice / 100
      if(hiddenHaloPrice > 0) {
        $('.hiddenhalo').text('Hidden Halo  (+'+formatter.format(hiddenHaloPrice)+')')
      } else {
        $('.hiddenhalo').text('Hidden Halo  ('+formatter.format(hiddenHaloPrice)+')')
      }
      if(defaultitle !== 'Original Design') {
        $(".ProductForm__SelectedValue__Band").text(defaultitle + ' (+'+formatter.format(hiddenHaloPrice)+')')
      } else {
        $(".ProductForm__SelectedValue__Band").text("No Hidden Halo")
      }
      $(".ProductForm__Bandbtn").attr("aria-controls", "popover-band-list")
      $(".ProductForm__Bandbtn").find(".arror-icon").removeClass("hide")
      $("#popover-band-list").removeClass("hide")
      $('.hiddenhalo').text('Hidden Halo '+ '(+'+formatter.format(hiddenHaloPrice)+')')
    } else {
      $(".ProductForm__SelectedValue__Band").text(defaultitle)
    }
  }
}

/** * When diamond is changed from dropdown then removing the localstorage also * **/
function deSelectDiamondOnVariantChange() {
  $("span.selectedDiamond").text('Select')
  $("#selectedDiamondShape").val('')
  $("#selectedDiamondObj").val('')
  removeVowLocalstorageItems()
}

/*** for adding tabindex to eachfunction  **/
$(function() {
  var tabindex = 0;
  $('.tabindexfunction,a').each(function() {
    if (this.type != "hidden") {
      var $input = $(this);
      $input.attr("tabindex", "0");
    }
  });
});

/* Close dropdown when click on Sizechart */
var buttonWithAriaControls = $('[aria-controls="modal-size-chart"]');
buttonWithAriaControls.on('click', function() {
  $('.Popover').attr('aria-hidden','true')
  $('.ProductForm__Item').attr('aria-expanded','false')
})   
 
/* Remove overlay on Size Modal close */
setTimeout(function () {
  $(".Modal__Close").on('click',function() {
    $(".PageOverlay").removeClass("is-visible");
    $('.PageOverlay').trigger('click')
  }) 
}, 500);

function saveDiamondAndGetVariantId(cb) {
  let selectedDiamond = localStorage.getItem("seletedDiamond");
  // Check if diamond is selected
  if (!selectedDiamond) {
    alert("You already selected Diamond");
    window.location.reload();
    return cb("Diamond or your localstorage has no diamond", null, null);
  }

  let diamond = JSON.parse(selectedDiamond);
  let certNum = diamond.handle;
  let diamondShape = diamond.title.split(" #")[0];
  // Ensure certNum is available
  if (!certNum) {
    showErrorMessage("certNum is empty");
    return cb("certNum is empty", null, null);
  }

  // Fetch the cart data
  fetch("/cart.js")
    .then(response => response.json())
    .then(cartJson => {
      // Fetch the product data from Shopify using the certNum
      getProductFromShopify(certNum, async (error, data) => {
        if (data && data.variants && data.variants.length) {
          // If the product exists in Shopify, get the variant ID
          const diamondVariantId = data.variants[0].id;
          return cb(null, diamondVariantId, data);
        }
        // If product is not found, add the diamond product via API
        try {
          const myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/json");
          const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify({ product: diamond }),
            redirect: 'follow'
          };

          const response = await fetch(storePrivateApiUrl + '/product?shop=' + storeUrlJs, requestOptions);
          const result = await response.json();

          if (result.product && result.product.variants.length) {
            const diamondId = result.product.variants[0].id;
            // Save the product image if needed
            saveProductImage(result.product.id, removeCharWithLowerCase(diamondShape), (error, data) => {
              if (error) {
                console.log("Error adding image:", error);
                return cb(null, diamondId, result.product);
              }
              console.log("Image added successfully:", data);
              return cb(null, diamondId, result.product);
            });
          }
        } catch (error) {
          console.error("Error during product fetch:", error);
          return cb(error, null, null);
        }
      });
    })
    .catch(error => {
      console.error("Error fetching cart data:", error);
      return cb(error, null, null);
    });
}

function saveProductImage(productId, shape, cb) {
  if (!productId || !shape) {
    cb("productId and shape are required", null);
    return;
  }
  const selectedDiamond = localStorage.getItem("seletedDiamond");
  const diamond = selectedDiamond ? JSON.parse(selectedDiamond) : null;
  let imageUrl = "https://rc-diamond-images.s3.us-east-2.amazonaws.com/defaultDiamondImages/noImage.png";   // Default image URL

  // Check if diamond tags contain a valid image URL
  if (diamond?.tags?.[13]?.includes("http")) {
    imageUrl = diamond.tags[13].replace("image_file_url: ", "");
  } else {
    // Shape-based image URLs
    const shapeImageUrls = {
      "round": "https://cdn.shopify.com/s/files/1/1359/2701/files/round.png",
      "oval": "https://cdn.shopify.com/s/files/1/1359/2701/files/oval.png",
      "pear": "https://cdn.shopify.com/s/files/1/1359/2701/files/pear.png",
      "radiant": "https://cdn.shopify.com/s/files/1/1359/2701/files/radiant.png",
      "cushion": "https://cdn.shopify.com/s/files/1/1359/2701/files/cushion.png",
      "emerald": "https://cdn.shopify.com/s/files/1/1359/2701/files/emrald.png",
      "antique-styleround": "https://cdn.shopify.com/s/files/1/1359/2701/files/antiquestyleround.png",
      "antiquestyleround": "https://cdn.shopify.com/s/files/1/1359/2701/files/antiquestyleround.png",
      "antique-stylecushion": "https://cdn.shopify.com/s/files/1/1359/2701/files/antiquestylecushion.png",
      "antiquestylecushion": "https://cdn.shopify.com/s/files/1/1359/2701/files/antiquestylecushion.png",
      "princess": "https://cdn.shopify.com/s/files/1/1359/2701/files/princess.png",
      "marquise": "https://cdn.shopify.com/s/files/1/1359/2701/files/marquise_pink.jpg?v=1702374856",
    };
    imageUrl = shapeImageUrls[shape] || imageUrl;
  }
  // Prepare request body
  const body = {
    apiUrl: `${apiUrlPath}${apiVersion}products/${productId}/images.json`,
    method: "POST",
    data: {
      image: {
        src: imageUrl,
        filename: "defaultDiamondImage.png",
      },
    },
  };
  // Perform API call
  commonApiCalls(body, (data) => {
    cb(null, data);
  });
}
  
let vowCartItems = [];
let checkClickedBtnText = '';

function checkforAddVowtoCart(e) {
  checkClickedBtnText = jQuery(e).html();
  if (!selectedDiamond) {
    console.log("Some error in sending recipient data");
    return;
  }

  jQuery(e).html("Adding...");
  $('#openEngravingModal, #openEngravingModalCheckout').prop('disabled', true)
    .addClass('custom-disabled-btn')
    .attr('href', 'javascript:void(0)')
    .removeAttr('onclick');
  fetch("/cart.js")
    .then(response => response.json())
    .then(cartData => {
      vowCartItems = cartData.items
        .filter(item => item.product_type === 'Vow Engagement Rings' || item.product_type === 'Diamond')
        .map(item => item.id);
      addVowProductToCartApi()
    })
    .catch(error => {
      console.error("Error fetching cart data:", error);
    });
}

function addVowProductToCartApi() {
  const boxClass = $(window).width() >= 768 ? "product-diamond-shape-selection" : "ProductForm__mobile-view";
  const bandWidth = grabBandWidth;
  const cartData = fetchCartData;
  const formData = getFormData();
  var unique_key = (Math.random() + 1).toString(36).substring(2);

  if (!formData) return;

  $('.engravingModal_btn').attr("disabled", true);

  saveDiamondAndGetVariantId((error, diamondId, productInfo) => {
    if (error) {
      showErrorMessage(error);
      console.error("Error while saving diamond:", error);
      return;
    }

    /* Check Lab Grown Diamond through Vendor or Product Tag */
    var isLabGrown = false;
    const labGrownVendors = ['SL', 'GR', 'FN', 'MD', 'Aarush', 'RC', 'EL', 'OML'];
    if (labGrownVendors.includes(productInfo.vendor) || productInfo.tags.includes("LG")) {
      isLabGrown = true;
    }
    let dataToSend = { ...formData, properties: { ...formData.properties, DiamondId: diamondId, 'Diamond Type': isLabGrown ? "Lab Grown Diamond" : "Natural Diamond", '_associated_unique_key': unique_key } };
    new Promise((resolve) => {
      if (productInfo?.variants[0]?.inventory_quantity === 0) {
        $("#engravingModal").hide();
        showErrorMessage("Your selected diamond has been sold! Please choose another one");
        console.log("Diamond sold! Reloading...");
        deSelectDiamondOnVariantChange();
        setTimeout(() => window.location.reload(), 3000);
        return;
      }
      const certNumber = JSON.parse(localStorage.getItem("_raw_diamond_info"))?.certNum || 0;

      /* Calculating DP Identifier Price with Diamond Product Data */
      var authenticateTotalSalesPrice = 0;
      if (productInfo?.tags) {
        var match = productInfo.tags.match(/price:\s*([\d.]+)/);
        if (match && match[1]) {
          authenticateTotalSalesPrice = parseFloat(match[1]).toFixed(2);
        }
      }
      
      var rawMarkUpPrice = dataToSend?.properties['_markupPrice'] || 0;
      var authenticateMarkUpPrice = typeof rawMarkUpPrice === 'string' ? parseFloat(rawMarkUpPrice.replace(/[$,]/g, '')).toFixed(2) : parseFloat(rawMarkUpPrice).toFixed(2);
      var finalAuthenticatedDpPrice = 0;
      if(authenticateTotalSalesPrice && authenticateMarkUpPrice && 
         authenticateMarkUpPrice !== 0 && authenticateTotalSalesPrice !== 0 &&
         !isNaN(parseFloat(authenticateMarkUpPrice)) && !isNaN(parseFloat(authenticateTotalSalesPrice))) {
        finalAuthenticatedDpPrice =  (parseFloat(authenticateTotalSalesPrice) + parseFloat(authenticateMarkUpPrice)).toFixed(2)
      } 
      
      const items = [
        {
          id: parseInt(diamondId),
          quantity: 1,
          properties: {
            'Carat': dataToSend.properties['Carat'],
            'Clarity': dataToSend.properties['Clarity'],
            'Cut': dataToSend.properties['Cut'],
            'Color': dataToSend.properties['Color'],
            'Diamond Measurement': dataToSend.properties['Diamond Measurement'],
            'Diamond': productInfo.tags.includes("LG") ? "Lab Grown Diamond" : "Natural Diamond",
            '_dp_identifier': !isNaN(finalAuthenticatedDpPrice) ? finalAuthenticatedDpPrice : 0,
            '_gia_cert_number': certNumber,
            '_associated_unique_key': unique_key
          }
        },
        dataToSend.properties.BandId ? {
          id: parseInt(dataToSend.properties.BandId),
          title: dataToSend.properties.BandType,
          quantity: 1
        } : null,
        dataToSend
      ].filter(Boolean);

      resolve(items);
    })
    .then((items) => {
      return $.ajax({
        url: '/cart/add.js',
        method: 'POST',
        data: { items },
        dataType: 'json'
      });
    })
    .then((response) => {
      if (response?.items.length) {
        console.log("All items added to cart successfully!");
        removeVowLocalstorageItems();
        $('.engravingModal_btn').text("Added to cart");
        setTimeout(() => {
          window.location.href = checkClickedBtnText === 'checkout now' ? '/checkout' : '/cart';
        }, 500);
      } else {
        showErrorMessage(response.description);
        $('.engravingModal_btn').removeAttr("disabled");
      }
    })
    .catch((error) => {
      showErrorMessage(error?.description || "An error occurred while adding items to cart.");
      $('.engravingModal_btn').removeAttr("disabled");
    });
  });
}

function redirectToDiamondSelectPage(){
  var currentUrl = window.location.href;
  if (currentUrl.includes('preCart=true')) {
    var updatedUrl = currentUrl.replace('preCart=true', 'preCart=false');
    window.location.href = updatedUrl;
  } else if (!currentUrl.includes('preCart=false')) {
    var separator = currentUrl.includes('?') ? '&' : '?';
    var updatedUrl = currentUrl + separator + 'preCart=false';
    window.location.href = updatedUrl;
  }
}

function updateMetalLabel(selectedMetal) {
  var metalLabel = document.getElementById('metalColorLabel');
  metalLabel.textContent = 'Metal: ' + selectedMetal;
}

function updateSelectedMetalClass(selectedElement) {
  var selectedMetal = selectedElement.getAttribute('data-value');
  var buttons = document.querySelectorAll('.SelectedMetal');
  buttons.forEach(function (button) {
    button.classList.remove('selected-metal-class');
  });
  selectedElement.classList.add('selected-metal-class');
  updateMetalLabel(selectedMetal);
}

var buttons = document.querySelectorAll('.SelectedMetal');
buttons.forEach(function (button) {
  button.addEventListener('click', function () {
    updateSelectedMetalClass(button);
  });
});

// Initial call to set the correct value on page load
var initialSelectedMetal = document.querySelector('.SelectedMetal.selected-metal-class');
if (initialSelectedMetal) {
  updateMetalLabel(initialSelectedMetal.getAttribute('data-value'));
}	